import { FC, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IType } from '../../../models/evaluation.model';
import { RootState } from '../../../store/rootReducer';

import { useSnackbar } from 'notistack';
import { Descriptions, Select } from 'antd';

import Button from '../../Button';
import useAuth from '../../../hooks/useAuth';
const { Option } = Select;

interface IProps {
  type: IType | null;
  onSubmit: Function;
}

const ProgramConvertEditor: FC<IProps> = ({ type, onSubmit }) => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // GR0002 = 평가 입력유형
  const GR0002 = commonCodes.find(item => item.commonCode === 'GR0002')?.detailCode;

  const [name, setName] = useState('');
  const [inputType, setInputType] = useState<any>(null);

  const nameInput = useRef<any>();

  useEffect(() => {
    if (type) {
      setName(type.typeName);
      setInputType(type.inputTypeCode);
    }
  }, [type]);

  const onSave = async () => {
    if (!name) {
      return enqueueSnackbar(t('program.convert.message1'), {
        variant: 'info'
      });
    }
    if (!inputType) {
      return enqueueSnackbar(t('program.convert.message2'), {
        variant: 'info'
      });
    }

    onSubmit({
      typeName: name,
      inputTypeCode: inputType,
    })
  }

  return (
    <div className='comm-table__area rowType mt-0'>
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label={t('program.convert.column1')}>
          <input
            type="text"
            className="form-control input-text"
            value={name}
            onChange={e => setName(e.target.value)}
            ref={nameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('program.convert.column2')}>
          <div className="w-210p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={inputType}
              onChange={value => setInputType(value)}
            >
              {
                GR0002?.map((item: any) => {
                  return (
                    <Option
                      key={item.detailCode}
                      value={item.detailCode}
                    >
                      {i18n.language === 'ko' ? item.korName : item.engName}
                    </Option>
                  )
                })
              }
            </Select>
          </div>
        </Descriptions.Item>
      </Descriptions>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            onClick={onSave}
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            className="btn-basic gray"
            onClick={() => history.push(`/program/convert`)}
            text={t('common.button.cancel')}
          />
        </div>
      </div>
    </div>
  )
}

export default ProgramConvertEditor;
